import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// CONSTANTS
import { ROUTE_START } from '@/constants/routes';
import { LOCATIONS_HOME_PARTNER_PAGE } from '@/constants/locations';

// UTILITY
import { analyticsStartFormLink } from '@/utility/analytics';

// COMPONENTS
import Link from '@/components/Link';
import ContentSearch from '@/components/ShowMovies/ContentSearch';

// STYLES
import { Container } from './styles';

const Hero = () => {
  const [t] = useTranslation();

  const { partner, partnerSettings, textOverwrites } = useSelector(({ partner: partnerStore }) => ({
    partner: partnerStore.data,
    partnerSettings: partnerStore.data?.settings || {},
    textOverwrites: partnerStore.data?.text_overwrites || {},
  }));

  let use_fmb = true;
  let use_marketplace = true;

  if (partner.partner_slug) {
    use_fmb = !!partnerSettings.use_fmb;
    use_marketplace = !!partnerSettings.use_marketplace;
  }

  const handleStartClick = () => {
    analyticsStartFormLink({
      location: LOCATIONS_HOME_PARTNER_PAGE,
      type: 'Button',
    });
  };

  return (
    <Container className="hero">
      <div className="page-content">
        <Grid container spacing={3} justifyContent="space-between">
          {use_fmb && (
            <Grid item xs={12} sm lg="auto">
              <div className="hero__info info info--right">
                <i className="info__icon icon-vintage-tv m-b-20" />
                <Typography className="m-b-15" component="h2" variant="h4">
                  {textOverwrites.partner_home_hero_title_left || t('partnerHome.hero.left.title')}
                </Typography>
                <Typography className="m-b-25 body3">
                  {textOverwrites.partner_home_hero_subtitle_left ||
                    t('partnerHome.hero.left.subtitle')}
                </Typography>
                <Button
                  endIcon={<i className="icon-arrow-right" />}
                  component={Link}
                  onClick={handleStartClick}
                  to={ROUTE_START}
                  color="primary"
                  location={LOCATIONS_HOME_PARTNER_PAGE}
                  fullWidth
                >
                  {t('buttons.getRecommendations')}
                </Button>
              </div>
            </Grid>
          )}
          {use_marketplace && (
            <Grid item xs={12} sm lg="auto">
              <div className="hero__info info info--left">
                <i className="info__icon icon-remote-control m-b-20" />
                <Typography className="m-b-15" component="h2" variant="h4">
                  {textOverwrites.partner_home_hero_title_right ||
                    t('partnerHome.hero.right.title')}
                </Typography>
                <Typography className="m-b-25 body3">
                  {textOverwrites.partner_home_hero_subtitle_right ||
                    t('partnerHome.hero.right.subtitle')}
                </Typography>
                <ContentSearch
                  analyticsLocation={LOCATIONS_HOME_PARTNER_PAGE}
                  textFieldProps={{ size: 'small' }}
                />
              </div>
            </Grid>
          )}
        </Grid>
      </div>
    </Container>
  );
};

export default React.memo(Hero);
